import type { FaireProductEntity } from "../../entity_types/product";

export const p_4abqq5vrzg: FaireProductEntity = {
  token: "p_4abqq5vrzg",
  type: "product",
  name: "Wide Wally Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/c533214636c00cff227f0a9ab3e5ee5361b8898cf0a9b3fb5513fe27a01ffd71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a7e5d499a536764c85f13e4049b6dcacdca5e28f5ac117dbf2b104f68457633.jpeg",
    "https://cdn.faire.com/fastly/4ba81bcb049455705afcbce07bb3c31e3b8ac5949c6d4a867e28b509ebb1c1e6.jpeg",
    "https://cdn.faire.com/fastly/a16ea87799e4a0b737e01bf7e04d2fecf7d51f0b84e853f3229e9d29b83b18c8.jpeg",
    "https://cdn.faire.com/fastly/fc339953461b920608756ed92a1eade3da76f1008503971f865b726c333cd6f0.jpeg",
    "https://cdn.faire.com/fastly/9835a5de0be0d319d6f5a818cc1a4e2a5480fa8a8ff78d737499af9678cfe076.jpeg",
    "https://cdn.faire.com/fastly/c37e060adeba5720b196d8f77f9dc4e6965826e5f8467ffd092b6f7fc4a6eda0.jpeg",
    "https://cdn.faire.com/fastly/bbc37fef4bf5246925fc46441bbf5d50c000728aafa5665bf73282a6e6e48b33.jpeg",
    "https://cdn.faire.com/fastly/45791e9f66c56150eb3d5c6d27551442deef174461e741592cb1cb9b88e2e64b.jpeg",
    "https://cdn.faire.com/fastly/a30dbbe1fefba3bf91106bf728b441ea613bffbc2681d93811d55702f3a8b238.jpeg",
    "https://cdn.faire.com/fastly/ada8cd772c2d070efd858b40b1f313db0d404bf0fdabb9b20fd63052784edf22.jpeg",
    "https://cdn.faire.com/fastly/fd8c121fbda36eea6f7ba4353883f7e7d66702f3b0b923bf3951623b8ba25eb6.jpeg",
    "https://cdn.faire.com/fastly/c16619f1e67255ac399c0aa5bec98efda10104c66d2c023a8b2b30b6f05463fa.jpeg",
    "https://cdn.faire.com/fastly/de1633696f556fab2efed6bad413024513c1bfd6ea8e3498b45fe82ad6f3c190.jpeg",
    "https://cdn.faire.com/fastly/5497e294f5b43853a9ad723dec3bc0246ff7b4e8bd6cc09054fe8eb959da1cd2.jpeg",
    "https://cdn.faire.com/fastly/f641ff2a5a1591814fd9a7c365ecacd178440336b5256ee9960fc465ebbb627b.jpeg",
    "https://cdn.faire.com/fastly/d7eb0df24af29dac1f7be391495cf1d89ff17a91b91f408bf6e7c3b2cdf4611d.jpeg",
    "https://cdn.faire.com/fastly/72736d94cc075b85ef581cfeb31bd8cee4c18032688a4e679d264bafff0a47bf.jpeg",
    "https://cdn.faire.com/fastly/e43d8cf40f2b2f3d6de161293c9fc93c8b3a91d65725b0d5a586fe066a5fcdf5.jpeg",
    "https://cdn.faire.com/fastly/752dee1c97f4a2152a084a1da2a5ad6f9f40b3001020993ef8b0c0e3d2a318d6.jpeg",
    "https://cdn.faire.com/fastly/16bf07a2eab5a3e76c7d864d38100c36822b7efeb2ac32802d6537cc73cc1a1e.jpeg",
    "https://cdn.faire.com/fastly/9ce0dc3adb04f2df2e9b65c6bbcf3adea7c2f6de22473fb90c09e47dedcc02f7.jpeg",
    "https://cdn.faire.com/fastly/1c2baa6e7ad5b42ff70a351fc0bc2574456ec7b4aab06103d7f07d20412bca04.jpeg",
    "https://cdn.faire.com/fastly/0d7fae56f20add9d77f51ce746dcb6f335e63d079678d389c0f6e78274352144.jpeg",
    "https://cdn.faire.com/fastly/aaba395bc21d3f7ec3afed3f4dad641014153b080bf9b3f204abe867ed3baa3c.jpeg",
    "https://cdn.faire.com/fastly/3f2d6da7e5499daaa8403504d9a221c92f8b34a072f8795832162f61b764c09d.jpeg",
    "https://cdn.faire.com/fastly/50ce646bcedbbf71f5fb401dfec7995d334849d1cfc219a443214e80b13fd981.jpeg",
    "https://cdn.faire.com/fastly/971318d8f7edf5d7a5640f87cf8cc69eb9ec05884c128a0304146df56ff4e770.jpeg",
    "https://cdn.faire.com/fastly/dc81469b177e36ebffa1273a5b729b9fd0e9e81357b0c99850150c47777fc79f.jpeg",
  ],
  priceDollars: 5,
  description:
    "Why We Made This?\n\nThese little striped darlings add a touché of Parisian chic to any look. Like our Sneaker Socks it is made from a breathable cotton blend that you can sweat, dance, jump and play in without leaving a mark on your skin like most sock bands do! \n\n\n\n\nMade in South Korea\n\n\n\n\nContents: \n\n70 Cotton 28 Polyester 2 Spdx\n\n\n\nSizing:\n\nOne size fits most (US women's size 6-10)\n\n\n\n\nCare Instructions:\n\nMachine wash cold\n\nTumble dry low\n\nDo not iron\n\nDo not bleach\n\n\n\n***Order in units of 6 (6,12,18,24 etc)\n\n\n\nMSRP: $10 USD\n",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:01.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
